<template>
  <div class="row-item">
    <div class="row-item__info">
      <span class="row-item__iconContainer">
        <iconic :name="module.icon || 'chart'" :class="['row-item__icon', `row-item__icon--${module.icon || 'chart'}`]" />
      </span>
      <span class="row-item__title">{{ module.title || module.module }}</span>
    </div>
    <div class="row-item__actions">
      <div v-for="action in actionButtons" :key="action.key" class="row-item__action" @mouseenter="hoveredAction = action.key" @mouseleave="hoveredAction = null">
        <ToolTip v-if="hoveredAction === action.key && isActionAllowed(action.key)" variant="down" :text="action.tooltip" class="row-item__tooltip" />
        <IconButton :icon="getActionIcon(action)" :active="isActionEnabled(action.key)" :disabled="!isActionAllowed(action.key)" @click="emitToggleAction(action.key)" />
      </div>
    </div>

    <label class="row-item__check">
      <input type="checkbox" :disabled="!isActionAllowed('enable')" :checked="isEnabled" @change="emitToggleEnable" />
    </label>
  </div>
</template>

<script>
  import ToolTip from "@/components/atoms/ToolTip.vue";
  import IconButton from "../IconButton/IconButton.vue";
  import { getAllowedActionsForModule } from "@/config/moduleActions";

  export default {
    name: "ModuleRow",
    components: { IconButton, ToolTip },
    props: {
      module: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        hoveredAction: null,
      };
    },
    computed: {
      actionButtons() {
        return [
          { key: "view", icon: "eyeIcon", altIcon: "restrictedEye", tooltip: "Solo lectura" },
          { key: "edit", icon: "pencilIcon", tooltip: "Edición y Creación" },
          { key: "delete", icon: "trashIcon", tooltip: "Eliminar / Cancelar" },
        ];
      },
      allowedActions() {
        return getAllowedActionsForModule(this.module.module);
      },
      isEnabled() {
        return this.module.actions?.includes("enable");
      },
    },
    methods: {
      isActionEnabled(action) {
        return this.module.actions?.includes(action);
      },
      isActionAllowed(action) {
        return this.allowedActions.includes(action);
      },
      getActionIcon(action) {
        if (action.key === "view") {
          return this.isActionEnabled("view") ? action.icon : action.altIcon || action.icon;
        }
        return action.icon;
      },
      emitToggleAction(action) {
        if (!this.isActionAllowed(action)) return;
        this.$emit("toggle-action", { id: this.module.id, action });
      },
      emitToggleEnable(event) {
        this.$emit("toggle-enable", { id: this.module.id, checked: event.target.checked });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .row-item {
    display: grid;
    grid-template-columns: minmax(160px, 1fr) minmax(120px, 1fr) auto;
    align-items: center;
    gap: 20px;
    width: 100%;
    padding: 11px 14px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.18);
    transition: all 0.3s ease;
    &:hover {
      background: #f7f7f7;
    }

    &__tooltip {
      top: -34px;
    }
    &__info {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      min-width: 0;
    }

    &__iconContainer {
      @include Flex();
      width: 24px;
      height: 24px;
    }
    &__icon {
      font-size: 24px;
      color: #3d3d3d;
      &--users {
        font-size: 18px;
      }
    }

    &__title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: #3d3d3d;
      font-family: $newFont_regular;
      font-size: 16px;
    }

    &__actions {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }

    &__action {
      position: relative;
      display: inline-flex;
    }

    &__check {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;

      input {
        width: 16px;
        height: 16px;
        cursor: pointer;
        appearance: none;
        border: 1px solid #d7d7d7;
        border-radius: 4px;
        background: #f5f5f5;
        transition: all 0.15s ease;

        &:checked {
          background: rgba(189, 9, 9, 0.05);

          border-color: $primary-color;
          box-shadow: inset 0 0 0 2px #fff;
        }

        &:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
      }
    }
  }
</style>
